module.exports = __webpack_public_path__ + "static/ir-798b81700d17131777ce8bd4e5b29ed4.svg";